import { FC } from 'react';

import { handleBannerTextGenerationChange } from 'utils/banner/utils';

import { MagritteBannerText } from 'components/common/MagritteBannerText/MagritteBannerText';

import { selectBannerDefaultText, selectBannerTextWasGenerated } from 'store/models/bannerTextGeneration';
import { setBannerText } from 'store/models/createBanner';
import { selectMainMenuVacancyId } from 'store/models/mainMenu';
import { useDispatch, useSelector } from 'store/utils';

export const BannerText: FC = () => {
    const vacancyId = useSelector(selectMainMenuVacancyId);
    const { bannerText, bannerErrors, bannerVacancyId } = useSelector((state) => state.createBanner);
    const bannerTextWasGenerated = useSelector(selectBannerTextWasGenerated);
    const defaultText = useSelector(selectBannerDefaultText);

    const dispatch = useDispatch();

    const onChange = (text: string) => {
        handleBannerTextGenerationChange(dispatch, text, defaultText, bannerTextWasGenerated);
        dispatch(setBannerText(text));
    };

    const setBannerGenerationText = (text: string) => dispatch(setBannerText(text));

    return (
        <MagritteBannerText
            value={bannerText}
            onChange={onChange}
            setBannerText={setBannerGenerationText}
            vacancyId={vacancyId || bannerVacancyId ? String(vacancyId || bannerVacancyId) : null}
            error={bannerErrors.bannerText}
            vSpacingBottom={32}
            dataQa="flexible-text-input"
        />
    );
};
